export default __webpack_public_path__ + "images/3a5a74e104985e31c5e06cae3215f520-rugby.webp";